import { Loc } from 'main.core';
import { ReactionName } from './reaction-name';

export const ReactionTitle = {
	[ReactionName.like]: Loc.getMessage('UI_REACTIONS_LIKE'),
	[ReactionName.faceWithTearsOfJoy]: Loc.getMessage('UI_REACTIONS_LAUGH_AND_CRY'),
	[ReactionName.redHeart]: Loc.getMessage('UI_REACTIONS_HEART'),
	[ReactionName.neutralFace]: Loc.getMessage('UI_REACTIONS_INDIFFERENT'),
	[ReactionName.fire]: Loc.getMessage('UI_REACTIONS_FIRE'),
	[ReactionName.cry]: Loc.getMessage('UI_REACTIONS_SORRY'),
	[ReactionName.slightlySmilingFace]: Loc.getMessage('UI_REACTIONS_SMILE'),
	[ReactionName.winkingFace]: Loc.getMessage('UI_REACTIONS_WINK'),
	[ReactionName.laugh]: Loc.getMessage('UI_REACTIONS_LAUGH'),
	[ReactionName.kiss]: Loc.getMessage('UI_REACTIONS_ADMIRE'),
	[ReactionName.wonder]: Loc.getMessage('UI_REACTIONS_SHOCK'),
	[ReactionName.slightlyFrowningFace]: Loc.getMessage('UI_REACTIONS_SAD'),
	[ReactionName.loudlyCryingFace]: Loc.getMessage('UI_REACTIONS_CRY'),
	[ReactionName.faceWithStuckOutTongue]: Loc.getMessage('UI_REACTIONS_TONGUE'),
	[ReactionName.faceWithStuckOutTongueAndWinkingEye]: Loc.getMessage('UI_REACTIONS_TEASING'),
	[ReactionName.smilingFaceWithSunglasses]: Loc.getMessage('UI_REACTIONS_COOL'),
	[ReactionName.confusedFace]: Loc.getMessage('UI_REACTIONS_DONT_KNOW'),
	[ReactionName.flushedFace]: Loc.getMessage('UI_REACTIONS_EMBARRASSMENT'),
	[ReactionName.thinkingFace]: Loc.getMessage('UI_REACTIONS_DOUBT'),
	[ReactionName.angry]: Loc.getMessage('UI_REACTIONS_ANGRY'),
	[ReactionName.smilingFaceWithHorns]: Loc.getMessage('UI_REACTIONS_MALEVOLENCE'),
	[ReactionName.faceWithThermometer]: Loc.getMessage('UI_REACTIONS_ILL'),
	[ReactionName.facepalm]: Loc.getMessage('UI_REACTIONS_NONSENSE_2'),
	[ReactionName.poo]: Loc.getMessage('UI_REACTIONS_POO'),
	[ReactionName.flexedBiceps]: Loc.getMessage('UI_REACTIONS_POWERFUL'),
	[ReactionName.clappingHands]: Loc.getMessage('UI_REACTIONS_GREAT'),
	[ReactionName.raisedHand]: Loc.getMessage('UI_REACTIONS_UP_FIVE'),
	[ReactionName.dislike]: Loc.getMessage('UI_REACTIONS_DISLIKE'),
	[ReactionName.smilingFaceWithHeartEyes]: Loc.getMessage('UI_REACTIONS_BEAUTIFUL'),
	[ReactionName.smilingFaceWithHearts]: Loc.getMessage('UI_REACTIONS_ADORE'),
	[ReactionName.pleadingFace]: Loc.getMessage('UI_REACTIONS_BEG'),
	[ReactionName.relievedFace]: Loc.getMessage('UI_REACTIONS_ZEN'),
	[ReactionName.foldedHands]: Loc.getMessage('UI_REACTIONS_THANKS'),
	[ReactionName.okHand]: Loc.getMessage('UI_REACTIONS_ОК'),
	[ReactionName.signHorns]: Loc.getMessage('UI_REACTIONS_ROCK'),
	[ReactionName.loveYouGesture]: Loc.getMessage('UI_REACTIONS_ALL_COOL'),
	[ReactionName.clownFace]: Loc.getMessage('UI_REACTIONS_CLOWN'),
	[ReactionName.partyingFace]: Loc.getMessage('UI_REACTIONS_CONGRATS'),
	[ReactionName.questionMark]: Loc.getMessage('UI_REACTIONS_QUESTION'),
	[ReactionName.exclamationMark]: Loc.getMessage('UI_REACTIONS_ATTENTION'),
	[ReactionName.lightBulb]: Loc.getMessage('UI_REACTIONS_IDEA'),
	[ReactionName.bomb]: Loc.getMessage('UI_REACTIONS_BOMB'),
	[ReactionName.sleepingSymbol]: Loc.getMessage('UI_REACTIONS_SLEEPING'),
	[ReactionName.crossMark]: Loc.getMessage('UI_REACTIONS_CROSS_MARK'),
	[ReactionName.whiteHeavyCheckMark]: Loc.getMessage('UI_REACTIONS_CHECK_MARK'),
	[ReactionName.eyes]: Loc.getMessage('UI_REACTIONS_EYES'),
	[ReactionName.handshake]: Loc.getMessage('UI_REACTIONS_HANDSHAKE'),
	[ReactionName.hundredPoints]: Loc.getMessage('UI_REACTIONS_HUNDRED_POINTS'),
};
